import React from "react";
import MIcon from "../../icons/MIcon";

/**
 * Select — single source of truth for dropdowns in the app.
 *
 * Replaces the page-specific RangePicker/OrgPicker pair so we don't keep
 * recreating the same icon-plus-chevron-styled <select> per feature.
 *
 * The chevron on the right is rendered ourselves (not via native styling)
 * so the control looks identical in every browser AND in dark mode.
 */
const Select = ({
  value,
  onChange,
  options,
  icon,
  placeholder,
  disabled = false,
  ariaLabel,
  className = "",
}) => {
  const hasIcon = Boolean(icon);
  const leftPadding = hasIcon ? "pl-9" : "pl-3";

  return (
    <div className="relative">
      {hasIcon && (
        <div className="absolute left-3 top-1/2 -translate-y-1/2 text-on-surface-light-variant dark:text-on-surface-variant pointer-events-none">
          <MIcon name={icon} className="sm" />
        </div>
      )}

      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        aria-label={ariaLabel ?? placeholder}
        className={`auth-input ${leftPadding} pr-8 py-2 rounded-lg text-sm font-body appearance-none cursor-pointer disabled:opacity-60 disabled:cursor-not-allowed ${className}`}
      >
        {placeholder !== undefined && <option value="">{placeholder}</option>}
        {options.map((o) => (
          <option key={o.value} value={o.value}>
            {o.label}
          </option>
        ))}
      </select>

      <div className="absolute right-2 top-1/2 -translate-y-1/2 text-on-surface-light-variant dark:text-on-surface-variant pointer-events-none">
        <MIcon name="expand_more" className="sm" />
      </div>
    </div>
  );
};

export default Select;
